export default "__VITE_ASSET__DqRa5HxA__"